export default "__VITE_ASSET__BpQZD7XY__"